'use strict';

import type { UserCalendarProvider } from '../../Entities/User/UserCalendarProvider';
import { EntityCollection } from '../EntityCollection';

export class UserCalendarProviderCollection extends EntityCollection<UserCalendarProvider> {}
